//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '~/components/Shared/Button.vue'
export default {
  components: {
    Button,
  },
  props: {
    label: {
      type: String,
      default: 'Salir',
    },
  },
  data() {
    return {
      isMobile: false,
    }
  },

  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
